import React, { Component } from "react";
import axios from "axios";
import validator from "validator";
import { FaFacebook, FaTwitter, FaLinkedin } from "react-icons/fa";

import Logo from "../../assets/img/full logo dark and blue.svg";

import {
  Container,
  Form,
  FormButton,
  FormContent,
  FormH1,
  FormInput,
  FromSelectInput,
  FormLabel,
  FormWrap,
  Icon,
  Text,
  LogoContainer,
} from "./RegistrationElements";

const initialState = {
  name: "",
  email: "",
  number: "",
  trainingSubject: "",
  statusMessage: "",
};

class SignIn extends React.Component {
  constructor(props) {
    super(props);

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      name: "",
      email: "",
      number: "",
      trainingSubject: "",
      statusMessage: "",
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    const name = this.state.name;
    const email = this.state.email;
    const number = this.state.number;
    const trainingSubject = this.state.trainingSubject;

    if (!name || !email) {
      this.setState(() => {
        return { statusMessage: "Please provide name and email" };
      });
    } else if (!validator.isEmail(email)) {
      this.setState(() => {
        return { statusMessage: "Please provide a valid email" };
      });
    } else if (!validator.isMobilePhone(number)) {
      this.setState(() => {
        return { statusMessage: "Please provide a valid number" };
      });
    } else if (!trainingSubject) {
      this.setState(() => {
        return { statusMessage: "Please provide your desired course" };
      });
    } else {
      console.log(name, email, number, trainingSubject);

      //API Call
      axios
        .post("/api-curigma/v1/training", {
          name,
          email,
          number,
          subject: trainingSubject,
        })
        .then((res) => {
          console.log(res);
          if (res.data.status === "success") {
            this.setState(() => {
              return { statusMessage: "We will contact you soon" };
            });
          } else if (res.data.status === "fail") {
            this.setState(() => {
              return { statusMessage: "Email already exist" };
            });
          }
        });
      this.setState(() => {
        return {
          statusMessage: "",
          name: "",
          email: "",
          number: "",
          trainingSubject: "",
        };
      });
    }
  }

  onChangeHandler(e) {
    const { name, value } = e.target;

    this.setState({ [name]: value });
    console.log(this.state);
  }

  render() {
    return (
      <Container>
        <FormWrap>
          <Icon to="/">
            <LogoContainer>
              <img src={Logo}></img>
            </LogoContainer>
          </Icon>
          <FormContent>
            <Form onSubmit={this.handleSubmit}>
              <FormH1>Register Here!</FormH1>
              <FormH1>{this.state.statusMessage}</FormH1>
              <FormLabel htmlFor="for">Name</FormLabel>
              <FormInput
                type="text"
                name="name"
                onChange={this.onChangeHandler}
                value={this.state.name}
                required
              />
              <FormLabel htmlFor="for">Email</FormLabel>
              <FormInput
                type="email"
                name="email"
                onChange={this.onChangeHandler}
                value={this.state.email}
                required
              />
              <FormLabel htmlFor="for">Number</FormLabel>
              <FormInput
                type="number"
                name="number"
                onChange={this.onChangeHandler}
                value={this.state.number}
                required
              />
              <FormLabel htmlFor="for">Training Subject</FormLabel>
              <FromSelectInput
                name="trainingSubject"
                onChange={this.onChangeHandler}
                defaultValue="Choose option"
                required
              >
                <option disabled>Choose option</option>
                <option value="JavaScript Core (Web Fundamentals)">
                  JavaScript Core (Web Fundamentals)
                </option>
                <option value="Core Web Development">
                  Web Development Core
                </option>
                <option value="Node JS">Node JS</option>
                <option value="React JS">React JS</option>
                <option value="Complete Web Development">
                  Complete Web Development
                </option>
              </FromSelectInput>
              <FormButton type="submit" onClick={this.handleSubmit}>
                Register
              </FormButton>
              <Text>
                Follow Us:{" "}
                <span>
                  <FaFacebook />
                </span>{" "}
                <span>
                  <FaTwitter />
                </span>{" "}
                <span>
                  <FaLinkedin />
                </span>
              </Text>
            </Form>
          </FormContent>
        </FormWrap>
      </Container>
    );
  }
}

export default SignIn;
